import React from 'react';

import type { CustomAlertType } from '@customTypes/alert';
import { useLocation } from '@gatsbyjs/reach-router';
import { CUSTOM_ALERTS } from '@consts/customAlerts';
import { Alert } from './Alert';

// TODO: возможно, я тут что-то сломал
export function CustomAlerts() {
  const location = useLocation();
  const currentPageUrl = location.pathname;

  return (
    <>
      {CUSTOM_ALERTS.filter((alert) => currentPageUrl.indexOf(alert.pathname) !== -1).map(
        (alert: CustomAlertType) => (
          <Alert key={`CustomAlert-${alert.key}`} alert={alert} />
        )
      )}
    </>
  );
}
